module.exports = __webpack_public_path__ + "img/grey-60days.f104149b.png";